import { Spinner } from "react-bootstrap";

export default function Loading({ processingStatus, fileUploadPercentage }) {
  const isLoading = Object.values(processingStatus).some(
    (status) => status !== "Pending"
  );

  if (!isLoading) return null; // Don't render anything if not loading

  function getStatusText(status) {
    switch (status) {
      case "Pending":
        return "⏳";
      case "In Progress":
        return (
          <Spinner
            as="span"
            animation="grow"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        );
      case "Completed":
        return "✅";
      case "Failed":
        return "❌";
      default:
        return null;
    }
  }

  return (
    <div className="loader-overlay">
      <div className="w-100 d-flex justify-content-center align-items-center">
        <div>
          <p>
            {getStatusText(processingStatus.FileUpload)} Uploading file (
            {fileUploadPercentage}%)
          </p>
          <p>{getStatusText(processingStatus.Analysis)} Analyzing file</p>
          <p>
            {getStatusText(processingStatus.AssessmentCreation)} Saving progress
          </p>
        </div>
      </div>
    </div>
  );
}